export default __webpack_public_path__ + "static/banner-renovation-smart-hacks-c81e0106e33eedf4672130a3314ffa49.jpg";